const baseApiUrl = 'https://suite.amoreternohn.com/api';

export const environment = {
    production: true,
    serviceWorker: true,
    apiUrl: baseApiUrl,
    displaySessionApiUrl: baseApiUrl,
    signalrHubUrl: `${baseApiUrl}/servicesMonitorHub`,
    monitorBaseUrl: 'https://servicios.amoreternohn.com',
    profileImageBaseUrl: 'https://eventos.amoreternohn.com/storage',
    tittle:'AESUITE',
    color:'#0d6efd',
    restrictedNavItems: [],
    auth: {
      accessTokenKey: 'ae_access_token',
      refreshTokenKey: 'ae_refresh_token',
      profileKey: 'ae_access_profile',
      profileEtagKey: 'ae_profile_etag',
      navEtagKey: 'ae_nav_etag',
      featuresEtagKey: 'ae_features_etag',
      permissionsVersionKey: 'ae_permissions_version',
    },
    features: {
      photoSlideshowEnabled: false
    },
    analytics: {
      enabled: true,
      measurementId: 'G-VWYK06Z51D'
    },
    sentry: {
      enabled: true,
      dsn: 'https://f02bb753dac611f189e03e7a9132963a@o4508043816927232.ingest.us.sentry.io/4509005018365952'
    },
    reimbursements: {
      maxReceiptBytes: 8 * 1024 * 1024
    },
  };
  
